/*
 * @Description:
 * @Author: dandan.Wu
 * @Date: 2021-01-28 17:46:01
 * @LastEditTime: 2021-02-04 09:42:33
 * @LastEditors: dandan.Wu
 */
import fetch from '@/utils/fetch'
import {
  applyURI,
  setVerifiURI,
  getCertifiUserInfoURI,
  getSettedUserInfoURI,
  setSettedPersonURI,
  getVerifiStatusURI,
  getrejectInfoURI,
} from './urls'

// export async function applySubmit(data: ApplyTypes.ApplyForm): Promise<any> {
//   return fetch.post(applyURI, data)
// }

// 提交实名信息
export async function applySubmit(
  data: ApplyTypes.CertificationForm
): Promise<any> {
  return fetch.post(setVerifiURI, data)
}

// 提交用户信息
export async function applyUserInfo(
  data: ApplyTypes.UserInfoForm
): Promise<any> {
  return fetch.post(setSettedPersonURI, data)
}

// 获取实名信息
export function getCertifiInfo(params: any): Promise<any> {
  return fetch.get(getCertifiUserInfoURI, { params: params })
}

// 获取实名认证状态
export function getCertifiStauts(params: any): Promise<any> {
  return fetch.get(getVerifiStatusURI, { params: params })
}

// 获取个人信息详情
export function getSettedInfo(params: any): Promise<any> {
  return fetch.get(getSettedUserInfoURI, { params: params })
}
